import Slider from "react-slick";
import { Col, Divider, Row } from "antd";
import "./product.less";
import gift from "src/shared/assets/images/landing/gift.svg";
import percent from "src/shared/assets/images/landing/percent.svg";
import clock from "src/shared/assets/images/landing/clock.svg";
import { ButtonC } from "src/shared/components";
import { ReactSVG } from "react-svg";
import { useRef } from "react";
import useDirection from "src/shared/hooks/useDirection";

const LProduct = ({ data }: any) => {
  const { priceSeprator } = useDirection();

  const ref = useRef();
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section id="products">
      <Row justify="center" align="middle" className="f-row">
        <Col xs={23} xl={20}>
          <Row justify="center" align="middle" gutter={[0, 10]}>
            <Col xs={24}>
              <h3> تعداد فالورهایی که می خواهید را انتخاب کنید </h3>
            </Col>
            <Col xs={24}>
              <Slider {...settings}>
                {data
                  ?.filter((item: any) => item.quantity == 1000)
                  ?.map((item: any) => (
                    <div className="cardP">
                      <h5 className="count">1000</h5>
                      <p className="title"> {item.subCategoryName}</p>
                      <Divider />
                      <p className="items">
                        <ul>
                          <li>
                            <ReactSVG src={gift} />
                            <span>200 هدیه فالور</span>
                          </li>
                          <li>
                            <ReactSVG src={clock} />
                            <span>تحویل سریع</span>
                          </li>
                          <li>
                            <ReactSVG src={percent} />
                            <span>20 درصد تخفیف</span>
                          </li>
                        </ul>
                      </p>
                      <Divider />
                      <div className="div-price">
                        <div className="price">
                          <strong>{priceSeprator(item.userPrice)}</strong>
                        </div>
                        <ButtonC>سفارش</ButtonC>
                      </div>
                    </div>
                  ))}
              </Slider>
            </Col>
            <Col xs={24}>
              <h5> برای مشاهده بسته ها از راست به چپ بکشید</h5>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LProduct;
